import React, { useState, useEffect } from 'react'
import '../css/kswitch.css'
import { t } from '../locale'

interface YesNoSwitchProps {
  initialValue?: boolean
  onChange?: (value: boolean) => void
  label?: string
}

const KSwitch: React.FC<YesNoSwitchProps> = ({ initialValue = false, onChange, label }) => {
  const [isChecked, setIsChecked] = useState<boolean>(initialValue)

  // 🔑 kad se promeni initialValue spolja (npr. agreed), update-uj lokalni state
  useEffect(() => {
    setIsChecked(initialValue)
  }, [initialValue])

  const handleToggle = () => {
    const newValue = !isChecked
    setIsChecked(newValue)
    onChange?.(newValue)
  }

  return (
    <div className='yes-no-switch-container'>
      {label && <span className='yes-no-switch-label'>{label}</span>}
      <label className='switch'>
        <input type='checkbox' checked={isChecked} onChange={handleToggle} />
        <span className='slider round'></span>
        <div className='switch-text'>
          <span className={`text-yes ${isChecked ? 'active' : ''}`}>{t('yes')}</span>
          <span className={`text-no ${!isChecked ? 'active' : ''}`}>{t('no')}</span>
        </div>
      </label>
    </div>
  )
}

export default KSwitch
